// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title___4Ncx","gameDetails":"styles_gameDetails__vds_E"};